<style src="./EventMap.scss" lang="scss"></style>
<template>
  <main class="event-map">
    <content-header path="Resultado" />

    <section class="list-container">
      <table>
        <thead>
          <tr class="filter-header">
            <th colspan="26">
              <section class="filters">
                <input
                  type="text"
                  v-model="searchText"
                  v-debounce="300"
                  @debounced="filterByText"
                  placeholder="Busque pelo número do item ou descrição"
                  class="textbox"
                />
                <select class="select" v-model="filters.winner">
                  <option value="">TODOS OS VENCEDORES</option>
                  <option
                    v-for="(winner, winnerIdx) in winnersList"
                    :key="winnerIdx"
                    :value="winner"
                    >{{ winner }}</option
                  >
                </select>
                <button
                  @click="filterByQuoted"
                  :class="{ button__active: filters.wasQuoted }"
                  class="button s-3"
                >
                  COTADOS
                </button>
                <button
                  @click="filterByAssociated"
                  :class="{ button__active: filters.wasAssociated }"
                  class="button s-3"
                >
                  ASSOCIADOS
                </button>
                <button
                  @click="filterByProposal"
                  :class="{ button__active: filters.haveProposal }"
                  class="button s-3"
                >
                  COM PROPOSTA
                </button>
              </section>
            </th>
          </tr>
          <group-header @toggle-column="toggleColumns" />
          <column-header
            ref="ColumnHeader"
            @header-view-contraction="setColumnContraction"
          />
        </thead>

        <list-items
          :list="filteredList"
          :column-contraction="headerColumnContraction"
        />
      </table>
    </section>
  </main>
</template>

<script>
import ContentHeader from "@/components/foundation/content-header/ContentHeader";
// import FilterResult from './components/filter-result/FilterResult'
import ColumnHeader from "./components/column-header/ColumnHeader";
import GroupHeader from "./components/group-header/GroupHeader";
import ListItems from "./components/list-items/ListItems";
import IsClosedTask from "@/components/foundation/is-closed-task/IsClosedTask";
import { DebounceDirective } from "@/components/primitives/helpers/debounce/Debounce";

export default {
  name: "EventMap",
  components: {
    ContentHeader,
    // FilterResult,
    ListItems,
    ColumnHeader,
    GroupHeader,
    IsClosedTask
  },
  directives: {
    debounce: DebounceDirective
  },
  data() {
    return {
      isStageOpened: false,
      items: [],
      filteredList: [],
      searchText: "",
      winnersList: [],
      filters: {
        wasQuoted: false,
        wasAssociated: false,
        haveProposal: false,
        winner: ""
      },
      headerColumnContraction: {
        costLab: false,
        costUnit: false,
        costTotal: false,
        maxLab: false,
        maxUnit: false,
        maxTotal: false,
        estimatedLab: false,
        estimatedUnit: false,
        estimatedTotal: false,
        proposalUnit: false,
        proposalTotal: false,
        minimumUnit: false,
        minimumTotal: false,
        rankingDistributor: false,
        rankingLab: false,
        rankingUnit: false,
        rankingTotal: false
      }
    };
  },
  computed: {
    stage() {
      return this.$store.getters["Board/STAGE_BY_NAME"]("Resultado");
    },
    eventId() {
      return this.$route.params.id;
    }
  },
  watch: {
    items: {
      handler() {
        this.applyFilter();
      },
      immediate: true
    },
    filters: {
      handler() {
        this.applyFilter();
      },
      deep: true
    }
  },
  mounted() {
    this.listAllItems();
  },
  methods: {
    async listAllItems() {
      const eventId = this.$route.params.id;
      if (!eventId) return false;
      const items = await this.$store.dispatch("EventMap/LOAD_EVENT", {
        eventId
      });
      const computedList = this.computeValues(items);
      this.items = Object.freeze(computedList);
    },
    applyFilter() {
      const wasQuoted = this.filters.wasQuoted;
      const wasAssociated = this.filters.wasAssociated;
      const haveProposal = this.filters.haveProposal;
      const haveWinner = this.filters.winner.length > 0;
      const haveSearchText = this.searchText.trim().length > 0;

      if (
        !wasQuoted &&
        !wasAssociated &&
        !haveProposal &&
        !haveWinner &&
        !haveSearchText
      ) {
        this.filteredList = [...this.items];
        return;
      }

      const filteredList = this.items.filter(i => {
        if (haveSearchText) {
          const regSearch = new RegExp(this.searchText.trim(), "gi");
          if (!isNaN(Number(this.searchText.trim()))) {
            if (Number(this.searchText.trim()) === Number(i.itemInfo.number)) {
              return true;
            } else {
              return false;
            }
          }
          if (regSearch.test(i.itemInfo.description)) {
            return true;
          } else {
            return false;
          }
        }

        if (wasQuoted && i.quoted.isQuoted) {
          return true;
        }

        if (wasAssociated && i.associated.isAssociated) {
          return true;
        }

        if (haveProposal && i.quoted.haveProposal) {
          return true;
        }

        if (haveWinner) {
          const listDistributor =
            i.result.winner.haveWinner &&
            i.result.winner.distributor.toString().trim();
          const filterDistributor = this.filters.winner.toString().trim();
          if (listDistributor === filterDistributor) {
            return true;
          }
        }

        return false;
      });
      this.filteredList = filteredList;
    },
    setColumnContraction(c) {
      this.headerColumnContraction = c;
    },
    toggleColumns(columns) {
      this.$refs.ColumnHeader.toggleAllColumn(columns);
    },
    computeValues(items) {
      const winnersList = new Set();

      const computedValues = items.map(i => {
        i = Object.assign(
          {
            cost: {},
            cmedQuoted: {},
            associated: {},
            quoted: {},
            itemInfo: {},
            result: {
              winner: i.result.winner,
              second: i.result.second,
              third: i.result.third
            }
          },
          i
        );

        const quantity = (i.itemInfo && i.itemInfo.quantity) || 0;
        const factor = (i.itemInfo && i.itemInfo.factor) || 0;

        const isQuoted = !!(i.quoted && i.quoted.lab);
        const isAssociated = !!(i.associated && !!i.associated.lab);
        const haveMaxPrice = !!(i.cmedQuoted && i.cmedQuoted.lab);
        const haveEstimated = !!(
          i.itemInfo &&
          i.itemInfo.estimatedPrice &&
          Number(i.itemInfo.estimatedPrice > 0)
        );
        const haveProposal = !!(i.quoted && i.quoted.proposalPrice);
        const haveMinumum = !!(i.quoted && i.quoted.minimumPrice);
        const haveWinner = !!(
          i.result &&
          i.result.winner &&
          i.result.winner.offer
        );
        const haveSecond = !!(
          i.result &&
          i.result.second &&
          i.result.second.offer
        );
        const haveThird = !!(
          i.result &&
          i.result.third &&
          i.result.third.offer
        );

        const quotedPrice = isQuoted ? i.quoted.price : 0;
        const associatedPrice = isAssociated ? i.associated.price : 0;
        const maxPrice = haveMaxPrice ? i.cmedQuoted.computedValue : 0;
        const estimatedPrice = haveEstimated ? i.itemInfo.estimatedPrice : 0;
        const proposalPrice = haveProposal ? i.quoted.proposalPrice : 0;
        const minimumPrice = haveMinumum ? i.quoted.minimumPrice : 0;
        const winnerPrice = haveWinner ? i.result.winner.offer : 0;
        const secondPrice = haveSecond ? i.result.second.offer : 0;
        const thirdPrice = haveThird ? i.result.third.offer : 0;

        const costBase = isQuoted ? quotedPrice : associatedPrice;

        const maxPerc = haveMaxPrice
          ? this.calculatePerc(costBase, maxPrice)
          : 0;
        const estimatedPerc = haveEstimated
          ? this.calculatePerc(costBase, estimatedPrice)
          : 0;
        const proposalPerc = haveProposal
          ? this.calculatePerc(costBase, proposalPrice)
          : 0;
        const minimumPerc = haveMinumum
          ? this.calculatePerc(costBase, minimumPrice)
          : 0;
        const winnerPerc = haveWinner
          ? this.calculatePerc(costBase, winnerPrice)
          : 0;
        const secondPerc = haveSecond
          ? this.calculatePerc(costBase, secondPrice)
          : 0;
        const thirdPerc = haveThird
          ? this.calculatePerc(costBase, thirdPrice)
          : 0;

        i.associated.isAssociated = isAssociated;
        i.quoted.isQuoted = isQuoted;
        i.cmedQuoted.haveMaxPrice = haveMaxPrice;
        i.itemInfo.haveEstimated = haveEstimated;
        i.quoted.haveProposal = haveProposal;
        i.quoted.haveMinumum = haveMinumum;
        i.result.winner.haveWinner = haveWinner;
        i.result.second.haveSecond = haveSecond;
        i.result.third.haveThird = haveThird;

        i.associated.total = associatedPrice * quantity * factor;
        i.quoted.priceTotal = quotedPrice * quantity * factor;
        i.cmedQuoted.total = maxPrice * quantity * factor;
        i.itemInfo.estimatedTotal = estimatedPrice * quantity * factor;
        i.quoted.proposalTotal = proposalPrice * quantity * factor;
        i.quoted.minimumTotal = minimumPrice * quantity * factor;
        i.result.winner.total = winnerPrice * quantity * factor;
        i.result.second.total = secondPrice * quantity * factor;
        i.result.third.total = thirdPrice * quantity * factor;

        i.cmedQuoted.perc = maxPerc;
        i.itemInfo.estimatedPerc = estimatedPerc;
        i.quoted.proposalPerc = proposalPerc;
        i.quoted.minimumPerc = minimumPerc;
        i.result.winner.perc = winnerPerc;
        i.result.second.perc = secondPerc;
        i.result.third.perc = thirdPerc;

        i.cost.price = isQuoted ? quotedPrice : associatedPrice;
        i.cost.lab = isQuoted ? i.quoted.lab : i.associated.lab;
        i.cost.total = isQuoted ? i.quoted.priceTotal : i.associated.total;

        if (i.result.winner.haveWinner) {
          winnersList.add(i.result.winner.distributor.trim());
        }
        return i;
      });

      this.winnersList = Object.freeze(Array.from(winnersList));
      return computedValues;
    },
    calculatePerc(v2, v1) {
      return ((v1 * 100) / v2 - 100).toFixed(0);
    },
    filterByText() {
      this.applyFilter();
    },
    filterByQuoted() {
      this.filters.wasQuoted = !this.filters.wasQuoted;
    },
    filterByAssociated() {
      this.filters.wasAssociated = !this.filters.wasAssociated;
    },
    filterByProposal() {
      this.filters.haveProposal = !this.filters.haveProposal;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/event-map/EventMap.vue